(() => {
  if (window.vertexaB2BReady) return;
  window.vertexaB2BReady = true;
  let selection = null;
  const requestLabels = {quote:'Quote',standard_sample:'Standard samples',custom_sample:'Custom samples',report:'Test reports'};
  const sync = () => {
    const form = document.querySelector('.b2b-quote-form');
    if (!form || form.querySelector('[data-b2b-success]')) return;
    const request = form.querySelector('[data-b2b-request]');
    const context = form.querySelector('[data-b2b-context]');
    const pack = form.querySelector('[data-b2b-pack]');
    const notice = form.querySelector('[data-b2b-selection]');
    if (!request || !context || !pack || !notice) return;
    request.value = requestLabels[selection?.request] || 'Quote';
    context.value = selection?.context || '';
    notice.hidden = !selection;
    form.querySelector('[data-b2b-selection-text]').textContent = selection ? `${selection.context} · ${request.value}` : '';
    if (selection && selection.pack !== 'unchanged') {
      const option = [...pack.options].find(o => o.dataset.pack === selection.pack);
      if (option) pack.value = option.value;
    }
  };
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const choice = event.target.closest('.vxb2b [data-b2b-choice],.vxw [data-b2b-choice]');
    if (choice && new URL(choice.href).origin === location.origin && new URL(choice.href).hash === '#quote' && new URL(choice.href).pathname === location.pathname) {
      const form = document.querySelector('.b2b-quote-form');
      if (!form) return;
      event.preventDefault();
      document.querySelectorAll('.vxb2b [aria-current="true"]').forEach(e=>e.removeAttribute('aria-current'));
      choice.setAttribute('aria-current','true');
      selection = {request:choice.dataset.request,pack:choice.dataset.pack,context:choice.dataset.context};
      sync();
      const target=document.querySelector('#quote');
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
      form.querySelector('input:not([type="hidden"])')?.focus({preventScroll:true});
      history.replaceState(null,'','#quote');
    }
    if (event.target.closest('[data-b2b-reset]')) {
      selection=null;
      document.querySelectorAll('.vxb2b [aria-current="true"]').forEach(e=>e.removeAttribute('aria-current'));
      sync();
    }
  });
  document.addEventListener('shopify:section:load',sync);
  document.addEventListener('shopify:block:select',event=>{
    if (!event.target.closest('.vxb2b')) return;
    const details=event.target.closest('details');
    if(details) details.open=true;
  });
  document.addEventListener('shopify:block:deselect',event=>{
    if(event.target.closest('.vxb2b')) {
      const details=event.target.closest('details');
      if(details) details.open=false;
    }
  });
})();

